import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import { Grid } from "@material-ui/core";
import { fetchDiasSobreTurnosAgenda } from '../../../actions/turnos/agenda';
import { fetchConToken } from '../../../helpers/fetch';
import { AlertFinalizadoStepper } from '../../stepper/AlertFinalizadoStepper';
import { armarParametros } from '../../../helpers/parametros';
import { finishSpinner, startSpinner } from '../../../actions/ui/spinner';

const WEEKDAYS_SHORT = [
    'DOM', 'LUN', 'MAR', 'MIE', 'JUE', 'VIE', 'SAB',
];

const WEEKDAYS_LONG = [
    'Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado',
];

const MONTHS = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

export const CalendarioSobreturno = ({idEspecialidad, idCentroMedico, idProfesional, idAfiliado, presencial, virtual,
    selectedDay, setearValor, setListaHorarios, idAfiliadoExterno}) => {
    const dispatch = useDispatch();
    const { itemsDiasSobreturno } = useSelector((state) => state.agenda);
    const [openQuestion, setOpenQuestion] = useState(false);
    
    const startDate = new Date(itemsDiasSobreturno[0]);
    const endDate = new Date(itemsDiasSobreturno[itemsDiasSobreturno.length-1]);

    const tempRef = React.useRef({});

    const handleDayClick = (day, { selected }) => {
        const selDay = day;
        if (idAfiliadoExterno === undefined)
            idAfiliadoExterno = 0;
        const verificarTurnosTomados = async () => {
            const response = await fetchConToken(`Agenda/traerPorAfiliadoFecha/${idAfiliado}/${idAfiliadoExterno}/${selDay.toISOString()}`);
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                const lista = await response.json();
                tempRef.current = selDay;
                if(lista.filter(s => s.idCm !== idCentroMedico).length === 0)   //Valido si tiene otro turno el mismo dia para diferente CM
                    seleccionarDia();
                else
                    setOpenQuestion(true);
            }
        };
        const verificarHorariosSobreturnos = async () => {
            dispatch(startSpinner());
            const parametros = armarParametros(idEspecialidad, idCentroMedico, idProfesional, presencial, virtual, selDay.toISOString());
            const response = await fetchConToken(`Agenda/traerHorariosParaSobreturnos?${parametros}`);
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                const lista = await response.json();
                if(lista.length > 0){
                    setListaHorarios(lista);
                    verificarTurnosTomados();
                }
            }
            dispatch(finishSpinner());
        };
        verificarHorariosSobreturnos();
    };

    useEffect(() => {
        setearValor('selectedDay', null);
        // eslint-disable-next-line
    }, [])

    const seleccionarDia = () => {
        setOpenQuestion(false);
        setearValor('selectedDay', tempRef.current);
    };

    const handleCloseAlert = () => {
        setOpenQuestion(false);
        tempRef.current = null;
        setearValor('selectedDay', null);
    };
    
    const getdisabledDays = (itemsDiasSobreturno) => {
        const d1 = (new Date(startDate.getFullYear(), startDate.getMonth(), 0));
        const d2 = (new Date(endDate.getFullYear(), endDate.getMonth(), 32));
    
        var oneDay = 24*3600*1000;
        for (var d=[],ms=d1*1,last=d2*1;ms<last;ms+=oneDay){
            const timeMs = new Date(ms).getTime()
            if(itemsDiasSobreturno.filter(s => new Date(s).getTime() === timeMs).length===0)
                d.push( new Date(ms) );
        }
        return d;
    }

    const disabledDays = getdisabledDays(itemsDiasSobreturno);

    useEffect(() => {
        dispatch( fetchDiasSobreTurnosAgenda(idEspecialidad, idCentroMedico, idProfesional, presencial, virtual) );
    }, [idEspecialidad, idCentroMedico, idProfesional, presencial, virtual, dispatch])

    return ( 
        <>
            <Grid container spacing={4} style={{marginTop: 10}}>
                <Grid item xs={12} md={6} >
                    {itemsDiasSobreturno.length > 0&&
                        <div>
                            <DayPicker
                                month={new Date(startDate.getFullYear(), startDate.getMonth())}
                                fromMonth={new Date(startDate.getFullYear(), startDate.getMonth())}
                                toMonth={new Date(endDate.getFullYear(), endDate.getMonth())}
                                disabledDays={disabledDays}
                                selectedDays={selectedDay}
                                onDayClick={handleDayClick}
                                //localization
                                locale={'esp'}
                                months={MONTHS}
                                firstDayOfWeek={1}
                                weekdaysLong={WEEKDAYS_LONG}
                                weekdaysShort={WEEKDAYS_SHORT}
                            />
                        </div>
                    }
                </Grid>
                {openQuestion && 
                    <AlertFinalizadoStepper
                        open={openQuestion}
                        pregunta={"Turno encontrado"}
                        dialogText={"Se ha encontrado un turno tomado para otro Centro Médico en el mismo día, desea continuar?"}
                        buttonCancel={"Cancelar"}
                        buttonSubmit={"Continuar"}
                        handleClose={handleCloseAlert}
                        handleSend={seleccionarDia}
                    />
                }  
            </Grid>
            
        </>
     );
}
 